export function parseResponse(response) {
  if (response.ok) {
    if (response.status === 204 || response.status === 202) {
      return undefined;
    }
    const etag = response.headers.get('ETag');
    return response.json().then(function (jsonResponse) {
      if (typeof jsonResponse === 'object') {
        jsonResponse.eTag = etag;
      }
      return jsonResponse;
    });
  } else {
    return response.json().then(function (message) {
      const error = parseError(message);
      throw error;
    });
  }
}

export function parseFile(response, fileName, contentType) {
  if (response.ok) {
    return response.blob().then(function (blobResponse) {
      const blob = new Blob([blobResponse], { type: contentType || blobResponse.type });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // IE and Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // In FF link must be added to DOM to be clicked
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  } else {
    return response.json().then(function (message) {
      const error = parseError(message);
      throw error;
    });
  }
}

const convertBlobToBase64 = blobResponse =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blobResponse);
  });

export function parseFileAsBase64(response) {
  if (response.ok) {
    return response.blob().then(convertBlobToBase64);
  } else {
    return response.json().then(function (message) {
      const error = parseError(message);
      throw error;
    });
  }
}

export function getFileNameFromHeader(response) {
  const contentDescription = response.headers.get('Content-Disposition');

  if (!contentDescription) {
    return null;
  }

  const contentDescriptionParts = contentDescription.split(';');
  const fileName = contentDescriptionParts.find(part => part.indexOf('filename=') !== -1);
  const fileNameUtf8 = contentDescriptionParts.find(part => part.indexOf("filename*=UTF-8''") !== -1);

  if (fileNameUtf8) {
    return decodeURI(fileNameUtf8.split('=')[1].substr(7)).replace(/"/g, '');
  }
  return fileName.split('=')[1].replace(/"/g, '');
}

function parseError(message) {
  const error = {
    title: message.title,
    geosecmaSolution: message.extensions?.GeosecmaSolution,
    geosecmaCode: message.extensions?.GeosecmaError ?? 500,
    statusCode: message.status
  };
  if (message.extensions.InnerMessage && message.extensions.InnerMessage !== '') {
    error.reason = message.extensions.InnerMessage;
  }
  if (message.detail && message.detail !== '') {
    error.stackTrace = message.detail;
  }
  return error;
}
